import {useEffect} from 'react';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$getRoot} from 'lexical';
import {$isMergeFieldNode} from 'components/lexical_editor/nodes/MergeFieldNode';
import {$isImageNode} from 'components/lexical_editor/nodes/ImageNode';
import _ from 'lodash';

export default function CleanupAssigneesPlugin({assignmentRules}) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!assignmentRules) return;

    const validAssignees = new Set([
      'employee',
      '',
      ...assignmentRules.map(rule => rule.assignee)
    ]);

    editor.update(() => {
      const root = $getRoot();
      const allNodes = root.getChildren();

      function processNode(node) {
        if ($isMergeFieldNode(node) || $isImageNode(node)) {
          const assignee = node.__assignee;
          if (assignee && !validAssignees.has(assignee)) {
            node.remove();
            return;
          }
        }

        if (node.getChildren) {
          const children = node.getChildren();
          children.forEach(child => processNode(child));
        }
      }

      allNodes.forEach(node => processNode(node));
    });
  }, [editor, assignmentRules]);

  return null;
}
